import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import CopyComponent from 'components/field/CopyComponent';
import StringInput from 'components/field/StringInput';
import FormItem from 'components/form/FormItem';

import AdvanceSettings from '../AdvanceSettings';
import ActivateStore from '../Fields/ActivateStore';
import * as S from '../SalesChannel.styled';

const Akinon = () => {
	const { t } = useTranslation();
	const {
		watch,
		formState: { isSubmitting, isLoading: isFormLoading }
	} = useFormContext();

	const isLoading = isSubmitting || isFormLoading;
	return (
		<S.StoreAccordion header="storeDetails" defaultVisible>
			<FormItem label="sc.storeName" isLoading={isLoading} required>
				<StringInput name="storeName" />
			</FormItem>
			<FormItem label="refreshToken" isLoading={isLoading}>
				<CopyComponent value={watch('token') || t('saveTheFormToGetToken')} buttonDisabled={!watch('token')} />
			</FormItem>
			<ActivateStore />

			<AdvanceSettings fields={['prefix', 'defaultWarehouse']} isLoading={isLoading} />
		</S.StoreAccordion>
	);
};

export default Akinon;
